"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _reactRhumb = require("react-rhumb");

var _reactRedux = require("react-redux");

var _BannerSection = _interopRequireDefault(require("pricing-pages-unified-ui/components/banners/BannerSection"));

var _CurrencyPicker = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/CurrencyPicker"));

var _FooterMicrocopy = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/FooterMicrocopy"));

var _ProductsAndPlansNavIds = _interopRequireDefault(require("pricing-pages-unified-ui/constants/ProductsAndPlansNavIds"));

var _CustomerSupport = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/CustomerSupport"));

var _Faq = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/Faq"));

var _Question = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/Question"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Tracking = require("../constants/Tracking");

var _getUsageTracker = _interopRequireDefault(require("../utils/getUsageTracker"));

var _Calculator = _interopRequireWildcard(require("./calculator/Calculator"));

var _HubCalcPlanSelectorTileContainer = _interopRequireDefault(require("./calculator/HubCalcPlanSelectorTileContainer"));

var _HubCalcPriceDisplayTileContainer = _interopRequireDefault(require("./calculator/HubCalcPriceDisplayTileContainer"));

var _HubSubtitle = _interopRequireDefault(require("./common/HubSubtitle"));

var _StyledBlob = _interopRequireDefault(require("./common/StyledBlob"));

var _TabLayout = _interopRequireDefault(require("./TabLayout"));

var _HubTierInfo = _interopRequireDefault(require("./product-pages/HubTierInfo"));

var _StandardProductPageTitle = _interopRequireDefault(require("./product-pages/StandardProductPageTitle"));

var _PageContainer = _interopRequireDefault(require("./common/PageContainer"));

var _HubInfoContainer = _interopRequireDefault(require("./common/HubInfoContainer"));

var _urls = require("pricing-pages-unified-ui/utils/urls");

var _DocumentUtils = require("pricing-pages-unified-ui/utils/DocumentUtils");

var _PhoneSupport = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/PhoneSupport"));

var _PhoneSupportFooter = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/PhoneSupportFooter"));

var _FailedLoadBanner = _interopRequireDefault(require("pricing-pages-unified-ui/components/loading/FailedLoadBanner"));

var _LoadingStateSelectors = require("pricing-pages-unified-ui/selectors/LoadingStateSelectors");

var _PhoneSupportWrapper = _interopRequireDefault(require("./common/phone-numbers/PhoneSupportWrapper"));

var _HsfsCard = _interopRequireDefault(require("./common/HsfsCard"));

var _ExperimentTreatmentSelectors = require("pricing-pages-unified-ui/selectors/ExperimentTreatmentSelectors");

var _ExperimentConstants = require("pricing-pages-unified-ui/constants/ExperimentConstants");

var _Mon307TalkToSalesAuthedCta = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/Mon307TalkToSalesAuthedCta"));

var _Hubs = _interopRequireDefault(require("self-service-api/constants/Hubs"));

var _laboratoryClient = require("laboratory-client");

var _Mon307StickyTtsBar = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/Mon307StickyTtsBar"));

var _Mon307Fab = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/Mon307Fab"));

var _queryParamUtils = require("../utils/queryParamUtils");

var _stateUtils = require("../utils/stateUtils");

var SALES = _ProductsAndPlansNavIds.default.SALES;

function SalesHubPage(_ref) {
  var hasPricingAndPurchasingSucceeded = _ref.hasPricingAndPurchasingSucceeded,
      hasPricingAndPurchasingFailed = _ref.hasPricingAndPurchasingFailed;
  (0, _react.useEffect)(function () {
    (0, _getUsageTracker.default)().track('pageView', {
      screen: _Tracking.SCREENS.PRODUCTS_PLANS,
      subscreen: _Tracking.SUBSCREENS.SALES_HUB
    });
  }, []);
  var mon307Treatment = (0, _reactRedux.useSelector)(_ExperimentTreatmentSelectors.mon307TreatmentSelector);
  (0, _react.useEffect)(function () {
    if (!mon307Treatment.isMocked) {
      (0, _laboratoryClient.logExposure)(mon307Treatment);
    }
  }, []);
  var mon307TtsStyle = (0, _reactRedux.useSelector)(_ExperimentTreatmentSelectors.mon307TtsStyleSelector);

  var _useActiveTerm = (0, _stateUtils.useActiveTerm)(),
      term = _useActiveTerm.activeTerm;

  var _useCalculatorState = (0, _stateUtils.useCalculatorState)(),
      _useCalculatorState2 = (0, _slicedToArray2.default)(_useCalculatorState, 2),
      calculatorState = _useCalculatorState2[0],
      setCalculatorState = _useCalculatorState2[1];

  (0, _queryParamUtils.useQueryParamsEffect)((0, _extends2.default)({
    term: term
  }, calculatorState));
  return _react.default.createElement(_TabLayout.default, {
    selectedPrimaryTab: "products",
    selectedSecondaryTab: "sales"
  }, mon307TtsStyle === _ExperimentConstants.MON307_TTS_STYLE_OPTIONS.STICKY_HEADER && _react.default.createElement(_Mon307StickyTtsBar.default, {
    hub: _Hubs.default.HUB_SALES
  }), _react.default.createElement(_PageContainer.default, {
    "data-selenium-id": "page-success"
  }, hasPricingAndPurchasingSucceeded && _react.default.createElement(_reactRhumb.NavMarker, {
    name: "SALES_PAGE"
  }), mon307TtsStyle === _ExperimentConstants.MON307_TTS_STYLE_OPTIONS.SIDE_FAB && _react.default.createElement(_Mon307Fab.default, {
    hub: _Hubs.default.HUB_SALES
  }), _react.default.createElement(_CurrencyPicker.default, {
    mon307MoveDown: mon307TtsStyle === _ExperimentConstants.MON307_TTS_STYLE_OPTIONS.SIDE_FAB
  }), _react.default.createElement(_StyledBlob.default, null), _react.default.createElement(_HubInfoContainer.default, null, _react.default.createElement(_FailedLoadBanner.default, {
    hasFailed: hasPricingAndPurchasingFailed
  }), _react.default.createElement(_StandardProductPageTitle.default, {
    hub: SALES,
    includeTrademark: true
  }), _react.default.createElement(_HubSubtitle.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: "pricing-pages.hubs.sales.description"
  })), mon307TtsStyle === _ExperimentConstants.MON307_TTS_STYLE_OPTIONS.BELOW_TITLE && _react.default.createElement("div", {
    className: "justify-center m-bottom-5"
  }, _react.default.createElement(_Mon307TalkToSalesAuthedCta.default, {
    hub: _Hubs.default.HUB_SALES,
    className: "p-y-4 p-x-7",
    location: _Tracking.BELOW_TITLE
  })), _react.default.createElement(_BannerSection.default, {
    hub: SALES
  }), _react.default.createElement(_HubTierInfo.default, {
    hub: SALES
  }), _react.default.createElement(_HsfsCard.default, null), _react.default.createElement(_PhoneSupportWrapper.default, null, _react.default.createElement(_PhoneSupport.default, {
    phoneSourceId: "sales-middle",
    screen: _Tracking.SUBSCREENS.SALES_HUB
  })), _react.default.createElement(_Calculator.CalculatorContext.Provider, {
    value: {
      state: calculatorState,
      setState: setCalculatorState
    }
  }, _react.default.createElement(_Calculator.default, {
    PlanSelectorComponent: _HubCalcPlanSelectorTileContainer.default,
    PriceDisplayComponent: _HubCalcPriceDisplayTileContainer.default
  })), _react.default.createElement(_CustomerSupport.default, null), _react.default.createElement(_Faq.default, null, _react.default.createElement(_Question.default, {
    questionKey: "sales.salesIntegrateCRM"
  }), _react.default.createElement(_Question.default, {
    questionKey: "sales.salesIntegrateEmail"
  }), _react.default.createElement(_Question.default, {
    questionKey: "sales.salesAvailableSupport",
    href: (0, _urls.getCommunityUrl)()
  }), _react.default.createElement(_Question.default, {
    questionKey: "sales.salesPaidSeats"
  }), _react.default.createElement(_Question.default, {
    questionKey: "sales.salesEnterpriseCommitment"
  }), _react.default.createElement(_FooterMicrocopy.default, null)), _react.default.createElement(_PhoneSupportFooter.default, {
    phoneSourceId: "sales-footer",
    screen: _Tracking.SUBSCREENS.SALES_HUB
  }))));
}

SalesHubPage.propTypes = {
  hasPricingAndPurchasingSucceeded: _propTypes.default.bool.isRequired,
  hasPricingAndPurchasingFailed: _propTypes.default.bool.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hasPricingAndPurchasingSucceeded: (0, _LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector)(state),
    hasPricingAndPurchasingFailed: (0, _LoadingStateSelectors.hasPricingAndPurchasingFailedSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _DocumentUtils.withDocumentTitle)(SalesHubPage, 'sales'));

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/SalesHubPage.js
// module id = 785
// module chunks = 5 6